






















import Vue from "vue";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { http } from "@/shared/https";
import { Action } from "vuex-class";
import moment from "moment";
import FilterComponent from "./Filter/Filter.vue";
import ApplicationCardComponent from "@/components/common/Cards/ApplicationCard.vue";
import { AppConstants as _app } from '@/shared/app.constants';

@Component({
  components: { FilterComponent, ApplicationCardComponent },
})
export default class ApplicantDashboardComponent extends Vue {
  @Action("setCallId", { namespace: "application" }) setCall: any;

  callTypes: any = _app.InitiativeCallType;
  isEmpty: boolean = false;
  calls: any = [];
  headers: any = [];
  headersSeparator: any = [];
  inset: boolean = true;
  props: ["item"];

  data() {
    var self = this;
    return { calls: self.calls };
  }

  mounted() {
    var self = this;
    http.get(`/api/Call/List`).then((resp: any) => {
      self.calls = resp.data.Items;
      if (self.calls.length <= 0 || self.calls == null || self.calls == undefined) {
        self.isEmpty = true;
      }
    });

    // return { calls: self.calls };
  }

  /** Create new application while register */
  showDeclaration(callId: number, programId: number, typeId: number) {
    var self = this;
    this.setCall(callId);

    this.$router.push({
      name: this.callTypes.find(t => t.TypeId === typeId)?.RouteName,
      query: { callId: callId.toString() },
    });
  }
  /** Called by child component */
  homePageCenterFilter(e) {
    var self = this;
    http.get(`/api/Call/List?${e}`).then((resp: any) => {
      self.calls = resp.data.Items;
    });
    return { calls: self.calls };
  }
  /*goes to Archive List page */
  gotoArchivepage() {
    this.$router.push("/ArchiveList");
  }
  gotoUsefulList() {
    this.$router.push("/UsefulDocsList");
  }
  gotoContactpage() {
    this.$router.push("/ContactInfo");
  }
}
